/**
 * @generated SignedSource<<355c6cf7484bc059ee94555ece3d5c78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Media_Catalog_Query_Pagination_Fragment$data = {
  readonly mediaItems: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly node: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly slug: string | null | undefined;
            readonly username: string | null | undefined;
          };
        } | null | undefined;
        readonly description: string | null | undefined;
        readonly fileSize: number | null | undefined;
        readonly id: string;
        readonly linkedCatalog: ReadonlyArray<{
          readonly id: string;
        } | null | undefined> | null | undefined;
        readonly linkedCatalogCount: number | null | undefined;
        readonly mediaDetails: {
          readonly sizes: ReadonlyArray<{
            readonly name: string | null | undefined;
            readonly sourceUrl: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly mediaItemUrl: string | null | undefined;
        readonly mimeType: string | null | undefined;
        readonly status: string | null | undefined;
        readonly title: string | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "Media_Catalog_Query_Pagination_Fragment";
};
export type Media_Catalog_Query_Pagination_Fragment$key = {
  readonly " $data"?: Media_Catalog_Query_Pagination_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Media_Catalog_Query_Pagination_Fragment">;
};

import Media_Catalog_Query_Pagination_Query_graphql from './Media_Catalog_Query_Pagination_Query.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "mediaItems"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "where"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": Media_Catalog_Query_Pagination_Query_graphql
    }
  },
  "name": "Media_Catalog_Query_Pagination_Fragment",
  "selections": [
    {
      "alias": "mediaItems",
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "RootQueryToMediaItemConnection",
      "kind": "LinkedField",
      "name": "__MediaCatalogComponent_query_mediaItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToMediaItemConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mediaItemUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mimeType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MediaDetails",
                  "kind": "LinkedField",
                  "name": "mediaDetails",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MediaSize",
                      "kind": "LinkedField",
                      "name": "sizes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sourceUrl",
                          "storageKey": null
                        },
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileSize",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NodeWithAuthorToUserConnectionEdge",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "username",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "linkedCatalogCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ZnglyVideo",
                  "kind": "LinkedField",
                  "name": "linkedCatalog",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToMediaItemConnectionPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootQuery",
  "abstractKey": null
};
})();

(node as any).hash = "aa2b0f5199de2e8a7a7cd979f5f96ec8";

export default node;
